import { render } from "./AdminTemplate.vue?vue&type=template&id=62dc7054&ts=true"
import script from "./AdminTemplate.vue?vue&type=script&lang=ts"
export * from "./AdminTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__